var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',[_c('div',{staticStyle:{"padding":"10px"}},[_c('app-breadcrumb',{attrs:{"history":_vm.breadcrumb},on:{"mutate":_vm.doMutate}}),_c('router-view')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }